import { useEffect } from 'react'
import { ModuleRenderer } from './ModuleRenderer'
import { usePageVariations } from '@hooks/usePageVariations'
import type { getLandingPage } from '@cms/getLandingPage'
import type { PressReleasePickedItem } from '@cms/data/getPressReleaseArticle'
import type { QRCodeCTAContentful } from '@cms/data/getLandingPage'

type GetLandingPage = NonNullable<Awaited<ReturnType<typeof getLandingPage>>>

type LandingPageDataFromQuery = GetLandingPage['landingPageData']

export type ModifiedQRCodeCTA = QRCodeCTAContentful & {
  appDownloadData: {
    websiteUrl: string
    appDownloadUrl: string
    requestUrl: string | URL
    ch?: string | null
    pr?: string | null
  }
}

type ModifiedPageDataFromQuery = Omit<LandingPageDataFromQuery, 'qrCodeCta'> & {
  qrCodeCta?: ModifiedQRCodeCTA
}

type LandingPageLoaderData = Omit<GetLandingPage, 'landingPageData'> & {
  landingPageData: ModifiedPageDataFromQuery
} & { latestPressReleases?: PressReleasePickedItem[] }

export type LandingPageData = NonNullable<
  Pick<LandingPageLoaderData, 'landingPageData' | 'latestPressReleases'>
>

export type LandingPageContent = NonNullable<
  LandingPageData['landingPageData']['content']
>[number]

export const LandingPage = ({
  loaderDataLandingPage,
}: {
  loaderDataLandingPage: LandingPageLoaderData
}) => {
  const { landingPageData, pageVariations, latestPressReleases } =
    loaderDataLandingPage || {}
  const { setLocalizedUrls } = usePageVariations()

  useEffect(() => {
    setLocalizedUrls(pageVariations)
  }, [pageVariations, setLocalizedUrls])

  if (typeof landingPageData.content === 'undefined') {
    return null
  }

  return (
    <div>
      <ModuleRenderer
        landingPageData={landingPageData}
        latestPressReleases={latestPressReleases}
      />
    </div>
  )
}
